import { api, ApiResponse } from './apiClient';
import { ACL, ACLUpdate, ACLValidation } from '@/types/acl';

// NOTA: El token de autenticación se maneja automáticamente en apiClient.ts
// No es necesario pasarlo manualmente en los headers ya que apiRequest()
// lee la cookie auth_token y la incluye en el header Authorization.

export const aclService = {
  getByName: async (aclName: string): Promise<ApiResponse<ACL>> => {
    return api.get<ACL>(`/acl/by-name/${encodeURIComponent(aclName)}`);
  },

  getACLs: async (): Promise<ApiResponse<ACL[]>> => {
    return api.get<ACL[]>('/acl/');
  },

  getRequiredRoles: async (): Promise<ApiResponse<string[]>> => {
    return api.get<string[]>('/acl/required-roles');
  },

  validateRoles: async (): Promise<ApiResponse<ACLValidation>> => {
    return api.get<ACLValidation>('/acl/validate');
  },

  updateACL: async (aclName: string, update: ACLUpdate): Promise<ApiResponse<ACL>> => {
    return api.put<ACL>(`/acl/${aclName}`, update);
  },

  createACL: async (acl: { acl_name: string; scope: string; forbidden?: string[] }): Promise<ApiResponse<ACL>> => {
    return api.post<ACL>('/acl/', acl);
  },

  deleteACL: async (aclName: string): Promise<ApiResponse<{ message: string }>> => {
    return api.delete<{ message: string }>(`/acl/${aclName}`);
  },
};
